import { Component, OnInit, ViewChild } from '@angular/core';
import { GtStripeService } from '../../services/gt-stripe.service';
import { StripeProductData } from '../../models/stripe/stripe-product-data';
import { SessionService } from '../../services/session.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AlertModalComponent } from '../alert-modal/alert-modal.component';
import { StripeElementsOptions, StripePaymentElementOptions } from '@stripe/stripe-js';
import { StripeElementsDirective, StripePaymentElementComponent, StripeService, injectStripe } from 'ngx-stripe';
import { BaseModalComponent } from 'src/app/core/base-modal.componant';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-stripe-payment-modal',
    templateUrl: './stripe-payment-modal.component.html',
    styleUrls: ['./stripe-payment-modal.component.scss'],
    standalone: false
})
export class StripePaymentModalComponent extends BaseModalComponent implements OnInit {
  readonly stripe = injectStripe();

  @ViewChild(StripeElementsDirective) elements!: StripeElementsDirective;
  @ViewChild(StripePaymentElementComponent) paymentElement!: StripePaymentElementComponent;

  public product: StripeProductData;
  public customerId: string;
  public stripePaymentIntentData: any = {};
  private paymentIntent: any;

  public elementsOptions: StripeElementsOptions = {
    appearance: {
      theme: 'stripe'
    },
    locale: 'en',
  };

  public paymentElementsOptions: StripePaymentElementOptions = {
    layout: {
      type: 'tabs',
      defaultCollapsed: false,
    }
  };

  constructor(public sessionService: SessionService,
    private stripeService: GtStripeService,
    private ngxStripeService: StripeService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<StripePaymentModalComponent>) {
    super();
  }

  ngOnInit(): void {
    this.createPaymentIntent();
  }

  createPaymentIntent() {
    this.isLoading = true;
    this.stripeService.createPaymentIntent(this.stripePaymentIntentData)
      .subscribe((result: any) => {
        if(this.product === undefined){
          this.ngxStripeService.changeKey(environment.stripe.token, {
            stripeAccount: this.sessionService.getUser().stripeAccountId
          });
        }

        this.paymentIntent = result;
        this.elementsOptions.clientSecret = result.client_secret.toString();
        this.isLoading = false;
      }, err => {
        this.isLoading = false
        console.log(err);
      });
  }

  cancelPaymentIntent() {
    this.isLoading = true;
    let data: any = {
      paymentIntentId: this.paymentIntent.id,
      options: {
        cancellation_reason: 'abandoned'
      }
    };

    if(this.product === undefined){
      data.requestOptions = {
        stripeAccount: this.sessionService.getUser().stripeAccountId
      }
    }

    this.stripeService.cancelPaymentIntent(data)
      .subscribe((result: any) => {
        this.elementsOptions.clientSecret = result.client_secret.toString();
        this.dialogRef.close();
        this.isLoading = false;
      }, err => {
        this.isLoading = false
        console.log(err);
      });
  }

  confirmPayment() {
    this.isLoading = true;
    this.stripe.confirmPayment({
      elements: this.paymentElement.elements,
      redirect: 'if_required'
    }).subscribe(result => {
      this.isLoading = false;
      if (result.error) {
        this.openAlertDialog('Payment Error', `There was an error processing your payment. Please try again.`, 'Close');
      } else {
        if (result.paymentIntent.status === 'succeeded') {
          this.openAlertDialog('Payment Successful', `Thank you!`, 'Close')
          this.dialogRef.close({status: 'success', paymentIntent: this.paymentIntent});
        } else {
          this.openAlertDialog('Payment Unsuccessful', result.paymentIntent.status.toString(), 'Close')
        }

      }
    }, err => {
      this.openAlertDialog('Payment Error', `There was an error processing your payment. Please try again. \n ${err}`, 'Close')
      console.log(err);
    });
  }

  openAlertDialog(title, body, submitText) {
    const alertDialog = this.dialog.open(AlertModalComponent);
    alertDialog.componentInstance.title = title;
    alertDialog.componentInstance.body = body;
    alertDialog.componentInstance.submitText = submitText;
  }
}
